<div class="userDetails__body">
  <div class="userDetails__headerWrapper">
    <div class="userDetails__header">
      <div class="userDetails__headerText">User details </div>

      <div class="userDetails__headerImages">
        @if (commonService.orgLock()) {
          @if (userId !== parentData?._id) {
            <img data-bs-toggle="tooltip" ngbTooltip="Edit" placement="left" appAccessControl allowedRoles="user.edit"
              class="userDetails__crossIcon" (click)="handleEditUser()"
              src="../../../../assets/Images/user-management/edit.svg" alt="edit" />
            }
            @if (
              userId !== parentData?._id &&
              ((parentData?.rootCompany || parentData?.company) !== parentData?.company?._id) &&
              !parentData.primary && parentData.status != 'New'
              ) {
              <div class="userDetails__border" appAccessControl allowedRoles="user.edit"></div>
              <img data-bs-toggle="tooltip" [ngbTooltip]="parentData?.status=='Active'?'Lock':'Unlock'" placement="left"
                appAccessControl allowedRoles="user.disable,user.delete" (click)="deleteUser(parentData?._id)"
                class="userDetails__crossIcon lock-img" [src]="parentData?.status === 'Active'? '../../../../assets/Images/user-management/user-lock.svg' : '../../../../assets/Images/user-management/user-unlock.svg'"
                alt="delete" />
              }
            }
            <div class="userDetails__border" appAccessControl allowedRoles="user.disable"></div>
            <img (click)="onCloseIconClick()" class="userDetails__crossIcon"
              src="../../../../assets/Images/user-management/Cross.svg" alt="close" />
            </div>
          </div>
        </div>
        <div class="userDetails__basicdetailsWrapper">
          <div class="userDetails__basicdetailsSection">
            <div class="mfa-disable">
              <div class="userDetails__subText">Basic details:
              </div>
              @if (selfDetails?.primary && commonService.orgLock()) {
                <div class="btn-mfa">
                  <app-common-button (clickEvent)="disabledMFA()" buttonClass="smallbutton" buttonLabel="MFA"></app-common-button>
                </div>
              }
            </div>
            <div>
              <div class="userDetails__nameheader">Name</div>
              <div class="userDetails__name">{{ parentData?.name }}</div>
            </div>
            <div>
              <div class="userDetails__nameheader">Email</div>
              <div class="userDetails__name">{{ parentData?.emailAddress }}</div>
            </div>
            <div class="userDetails__mobileDetails mb-2">
              <div class="userDetails__nameheader">Mobile Number</div>
              <div class="userDetails__name">{{ parentData?.mobileNumber }}</div>
            </div>
            <div class="userDetails__mobileDetails mb-2 row col-md-12" appAccessControl allowedModules="documentVault.bieStudentCertificate,documentVault.sscStudentCertificate">
              <div class="userDetails__nameheader">Designation</div>
              <div class="userDetails__name">{{ parentData?.bieDesignation }}</div>
              <div class="mb-2">
                <div class="userDetails__nameheader">Years Assigned</div>
                <div class="userDetails__name">{{ parentData?.userYear?.join(', ') || '-' }}</div>
              </div>
            </div>
            <div class="userDetails__assign" appAccessControl allowedModules="workFlow.enabled">
              <div class="userDetails__assignHead">
                <div class="userDetails__nameheader">Department</div>
                @if (!isEditingDepartment) {
                  <button type="button" class="userDetails__assignEdit" (click)="editDepartment()">
                    {{ parentData?.departments?.length ? 'Change' : 'Assign' }}
                  </button>
                }
              </div>

              @if (parentData?.departments?.length > 0 && !isEditingDepartment) {
                <div class="userDetails__chips">
                  <span class="userDetails__chip">
                    <span class="userDetails__chipText" [ngbTooltip]="departmentDisplay"
                      [placement]="'top-start'">{{ departmentDisplay }}</span>
                    <button type="button" class="userDetails__chipRemove" aria-label="Remove department"
                      ngbTooltip="Remove department" [placement]="'top'" (click)="unAssignDepartment()">
                      <svg viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
                        <path d="M1.5 1.5l7 7M8.5 1.5l-7 7" />
                      </svg>
                    </button>
                  </span>
                </div>
              }

              @if (!parentData?.departments?.length && !isEditingDepartment) {
                <div class="userDetails__assignEmpty">Not assigned</div>
              }

              @if (isEditingDepartment) {
                <div class="userDetails__assignField" (click)="getDepartmentsList()">
                  <app-auto-search-dropdown placeholder="Department" [listData]="departmentList" [isMultiSelect]="false"
                    (loadMore)="getDepartmentsList()" [previousSeletedValues]="previousSeletedDepartment"
                    (selectedValues)="onSelectedDepartment($event)"
                  (searchText)="getDepartmentsList($event)"></app-auto-search-dropdown>
                </div>
                <div class="userDetails__assignActions">
                  <app-common-button buttonClass="smallbutton" buttonLabel="Cancel"
                    (clickEvent)="cancelEditDepartment()"></app-common-button>
                  <app-common-button buttonClass="smallFilledButton" buttonLabel="Save" [loadingIcon]="loadAction"
                    (clickEvent)="saveDepartment(true)"></app-common-button>
                </div>
              }

              @if (errorMessage) {
                <p class="text-danger userDetails__assignError">{{errorMessage}}</p>
              }
            </div>

                <div class="userDetails__assign" appAccessControl
                  allowedModules="invoiceTrackingSystem.enabled">
                    <div class="userDetails__assignHead">
                      <div class="userDetails__nameheader">Material Group</div>
                      @if (!isEditingMaterialGroup) {
                        <button type="button" class="userDetails__assignEdit" (click)="editMaterialGroup()">
                          {{ parentData?.materialGroups?.length ? 'Change' : 'Assign' }}
                        </button>
                      }
                    </div>

                  @if (parentData?.materialGroups?.length > 0 && !isEditingMaterialGroup) {
                    <div class="userDetails__chips">
                      @for (group of parentData.materialGroups; track group._id) {
                        <span class="userDetails__chip">
                          <span class="userDetails__chipText" [ngbTooltip]="group?.name"
                            [placement]="'top-start'">{{ group?.name }}</span>
                          <button type="button" class="userDetails__chipRemove"
                            [attr.aria-label]="'Remove ' + group?.name" ngbTooltip="Remove material group"
                            [placement]="'top'" (click)="removeMaterialGroup(group)">
                            <svg viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="1.8"
                              aria-hidden="true">
                              <path d="M1.5 1.5l7 7M8.5 1.5l-7 7" />
                            </svg>
                          </button>
                        </span>
                      }
                    </div>
                  }
                  @if (!parentData?.materialGroups?.length && !isEditingMaterialGroup) {
                    <div class="userDetails__assignEmpty">Not assigned</div>
                  }

                  @if (isEditingMaterialGroup) {
                    <div class="userDetails__assignField" (click)="getMaterialGroupsList()">
                      <app-auto-search-dropdown placeholder="Material Group" [listData]="materialGroupList"
                        [isMultiSelect]="true" (loadMore)="getMaterialGroupsList()"
                        [previousSeletedValues]="previousSeletedMaterialGroups"
                        (selectedValues)="onSelectedMaterialGroups($event)"
                      (searchText)="getMaterialGroupsList($event)"></app-auto-search-dropdown>
                    </div>
                    <div class="userDetails__assignActions">
                      <app-common-button buttonClass="smallbutton" buttonLabel="Cancel"
                        (clickEvent)="cancelEditMaterialGroup()"></app-common-button>
                      <app-common-button buttonClass="smallFilledButton" buttonLabel="Save"
                        [loadingIcon]="loadMaterialGroupAction"
                        (clickEvent)="saveMaterialGroup(true)"></app-common-button>
                    </div>
                  }

                  @if (materialGroupErrorMessage) {
                    <p class="text-danger userDetails__assignError">{{materialGroupErrorMessage}}</p>
                  }
                </div>
              </div>
            </div>
            <div class="userDetails__basicdetailsWrapper">
              <div class="userDetails__basicdetailsSection">
                <div class="userDetails__subText">{{!isAdmin?'Branches assigned:':'Roles assigned:'}}</div>
                @for (branch of parentData?.assignedTo; track branch) {
                  <div class="assigned_block">
                    <div class="d-flex trow">
                      @if (!isAdmin) {
                        <div class="roles_container">
                          <p class="userDetails__nameheader">Branch</p>
                        </div>
                      }
                      <div class="roles_container">
                        <p class="userDetails__nameheader">Roles</p>
                      </div>
                    </div>
                    <div>
                      <div class="d-flex">
                        <div [class]="!isAdmin? 'roles_container':'hideBranch'" >
                          <p class="userDetails__name">{{ branch?.company?.name | uppercase }}</p>
                        </div>
                        <div>
                          @if (branch.isAdmin) {
                            <p class="userDetails__name">Admin{{ " " }}</p>
                          }
                          @for (role of branch.roles; track role) {
                            <p class="userDetails__name">{{ role?.name }} {{ " " }}</p>
                          }
                          @if (branch.roles.length == 0 && !branch.isAdmin) {
                            <p class="userDetails__name">NA</p>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
                @if (parentData?.assignedTo?.length == 0) {
                  <div class="assigned_block">
                    <div class="d-flex trow">
                      <div class="roles_container">
                        <p class="userDetails__nameheader">Branch</p>
                      </div>
                      <div class="roles_container">
                        <p class="userDetails__nameheader">Roles</p>
                      </div>
                    </div>
                    <div>
                      <div class="d-flex">
                        <div [class]="!isAdmin? 'roles_container':'hideBranch'" >
                          <p class="userDetails__name">NA</p>
                        </div>
                        <div>
                          <ng-container>
                            <p class="userDetails__name">NA</p>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
            <div class="userDetails__Section">
              @if (!isAdmin && (companyPrefs?.eSign?.enabled || envType === appType.sdex)) {
                <div class="userDetails__verification">
                  <div class="userDetails__subText">Verification status</div>
                  <div class="userDetails__verificationDetails">
                    <div class="row">
                      @if (companyPrefs?.eSign?.enabled) {
                      <div class="col-lg-6">
                        <div class="userDetails__verificationstatus d-flex justify-content-between block_width">
                          <div class="userDetails__nameheader">E-Sign Status</div>
                          @if (parentData?.eSignedAt) {
                            <div class="userDetails__verificationFieldStatus">
                              <img src="../../../../assets/Images/user-management/Verified.svg" alt="verified" />
                              <div class="userDetails__verificationFieldText">Verified</div>
                            </div>
                          }
                          @if (!parentData?.eSignedAt && permissionData?.isEsignApplicable) {
                            <div class="userDetails__verificationFieldStatus">
                              <img src="../../../../assets/Images/user-management/Unverified.svg" alt="unverified" />
                              <div class="userDetails__verificationUnverified">Unverified</div>
                            </div>
                          }
                          @if (!permissionData?.isEsignApplicable && !parentData?.eSignedAt) {
                            <div class="userDetails__verificationFieldStatus">
                              <img src="../../../../assets/Images/user-management/Unverified.svg" alt="unverified" />
                              <div class="userDetails__verificationUnverified">NA</div>
                            </div>
                          }
                        </div>
                        <div class="d-flex justify-content-between block_width">
                          <div class="userDetails__nameheader">E-Sign View</div>
                          @if (parentData?.eSignedAt) {
                            <div>
                              <app-common-icon [iconSrc]="'../../../../assets/Images/login/eye.svg'" class="" [toolTip]="!parentData?.downloadLoader ? 'E-Sign Preview' : ''"
                                [loadingIcon]='parentData?.downloadLoader'
                                (clickEvent)="getFile(parentData?.eSignSelfLink)" [className]="'document-info--options__Icons pointer-cursor'" [placement]="'left'"
                              ></app-common-icon>
                            </div>
                          }
                        </div>
                      </div>
                      }
                      @if (envType === appType.sdex) {
                        <div class="col-lg-6">
                          <div class="userDetails__nameheader">BlockchainKey</div>
                          <div class="userDetails__verificationstatus">
                            @if (parentData?.isKeyGenerated) {
                              <div class="userDetails__verificationFieldStatus">
                                <img src="../../../../assets/Images/user-management/Verified.svg" alt="verified" />
                                <div class="userDetails__verificationFieldText">Verified</div>
                              </div>
                            }
                            @if (!parentData?.isKeyGenerated && permissionData?.isBlockChainApplicable) {
                              <div class="userDetails__verificationFieldStatus">
                                <img src="../../../../assets/Images/user-management/Unverified.svg" alt="unverified" />
                                <div class="userDetails__verificationUnverified">Unverified</div>
                              </div>
                            }
                            @if (!permissionData?.isBlockChainApplicable && !parentData?.isKeyGenerated) {
                              <div class="userDetails__verificationFieldStatus">
                                <img src="../../../../assets/Images/user-management/Unverified.svg" alt="unverified" />
                                <div class="userDetails__verificationUnverified">NA</div>
                              </div>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
          @if (isSuccessToster) {
            <div>
              <app-toast [title]="successMessage" (closeToaster)="closeToster($event)"></app-toast>
            </div>
          }
